import BigNumber from 'bignumber.js';
export default function Price(props) {

  let price;

  if (props.selectedCharacter.length < 5) {
    price = 0.055;
  } else if (props.selectedCharacter.length < 10) {
    price = 0.054;
  } else if (props.selectedCharacter.length < 15) {
    price = 0.053;
  } else {
    price = 0.05;
  }

  // NOTE: 小数点以下の扱いは確認してください🙏
  const totalPrice = BigNumber(price).times(BigNumber(props.selectedCharacter.length)).toString();

  // 言語切替対象の文章
  const discountRate = (props.lang === 'ja') ? '5体以上の購入で1体の価格が安くなります（下記参照）' : 'You will get a discount by purchasing more than 5 Characters. (details in chart below)';

  return (
    <>
      <div className="price">
        Total
        <strong>{totalPrice}</strong>
        eth + gas fees
        <span className="price__unit">Unit Price {price} eth</span>
        <small>{discountRate}</small>
      </div>
    </>
  );
}

